import styled from 'styled-components';
import { css, breakpoints } from 'src/styles/theme';
import { WallboxSummaryStyled } from '../WallboxSummaryStyled';
import { rem } from 'polished';

export const WallboxSummaryAC = styled(WallboxSummaryStyled)`
    
`;
